/**
 * Projects event types for durable event recording (project:*).
 */
export enum ProjectEventType {
  PROJECT_CREATED = 'project:created',
  PROJECT_UPDATED = 'project:updated',
  PROJECT_DELETED = 'project:deleted',
  PROJECT_USER_GROUP_ATTACHED = 'project:user-group-attached',
  PROJECT_USER_GROUP_DETACHED = 'project:user-group-detached',
  PROJECT_RESOURCE_ATTACHED = 'project:resource-attached',
  PROJECT_RESOURCE_DETACHED = 'project:resource-detached',
}

/**
 * Pub/sub channel for projects events.
 */
export const PROJECTS_EVENTS_CHANNEL = 'projects:events';